import dynamic from 'next/dynamic';
import Link from 'next/link';
import React from 'react';
import { Button } from '../../../base-components/Button';
import FormCheckbox from '../../../base-components/Checkbox/FormCheckbox';
import { FormTextInput } from '../../../base-components/FormTextInput';
import { Card } from '../components/Card';
import { QrCode } from '../components/QrCode';
import styles from './Login.module.scss';
import { LoginProps } from './Login.type';

const CryptoField = dynamic(() => import('../components/CryptoField'), {
    ssr: false,
});

export const Login: React.FC<LoginProps> = ({ error }) => {
    return (
        <div className={styles.container}>
            <Card>
                <FormTextInput
                    name="email"
                    label="Логин (эл. почта)"
                    appearance="material"
                    className={styles.email}
                />
                <FormTextInput
                    type="password"
                    name="password"
                    label="Пароль"
                    appearance="material"
                    className={styles.password}
                />
                <Link href="/auth/restore/send-mail">
                    <a className={styles.forgot}>Забыли пароль?</a>
                </Link>
                <FormCheckbox name="remember" className={styles.remember}>
                    Запомнить меня на этом компьютере
                </FormCheckbox>
                <Button type="submit" size="large" className={styles.submit}>
                    Войти на площадку
                </Button>
                <CryptoField name="thumbprint" className={styles.crypto} />
                {Boolean(error) && <div className={styles.error}>{error}</div>}
                <div className={styles.setup}>
                    <Link href="/test_eds">
                        <a>Как настроить ЭП для входа</a>
                    </Link>
                </div>
                <QrCode />
            </Card>
        </div>
    );
};
